import { api, ecomAPI } from './Axios'

export const EcomAPI = {
    getProductById(id) {
        return ecomAPI.get('?url=products/' + id)
    },

    getUserPricing(product_id, user_id) {
        return api.get(
            `tiered-pricing/v1/pricing/product/${product_id}/user/${user_id}`,
        )
    },
}
